<div class="change-pin-content pointer-events-none" *ngIf="!isSeparateZone; else separateZoneTemplate">
  <div
    class="widget-box"
    (click)="openChangePinPopup()"
    [ngClass]="{
      'is-workflow': isWorkflow,
      'disable-widget': !isWidgetEnabled
    }"
  >
    <div class="widget-icon" [ngStyle]="borderStyle">
      <mat-icon class="change-pin" svgIcon="change-pin"></mat-icon>
    </div>
    <label for="title" class="label" [ngStyle]="textContentStyle" [ngClass]="{ 'is-workflow': isWorkflow }">
      Change PIN
    </label>
  </div>
</div>

<ng-template #separateZoneTemplate>
  <div
    class="change-pin-content separate-zone pointer-events-none"
    [ngStyle]="contentStyle"
    style="height: 98%"
    [ngClass]="{
      'disable-widget': !isWidgetEnabled
    }"
  >
    <div class="list-box" (click)="openChangePinPopup()">
      <div class="l-section">
        <div class="image">
          <mat-icon class="change-pin" svgIcon="change-pin"></mat-icon>
        </div>
      </div>
      <div class="center-section" style="width: 100%">
        <div class="title">Change PIN</div>
        <div class="sub-title">Change PIN for your card</div>
      </div>
    </div>
  </div>
</ng-template>

<div *ngIf="showAirwallexIframe" class="change-pin-iframe mt-4">
  <div *ngIf="iframeError">{{ iframeError }}</div>
  <div *ngIf="iframeMessage">{{ iframeMessage }}</div>
  <div [id]="iframeHostId"></div>
</div>
